"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TOLL_FREE_AREA_CODES = ['800', '888', '877', '866', '855', '844', '833'];
/**
 * Internal implementation for isTollFree(). Takes a ParsedPhoneNumber object instead of a
 * string.
 */
function isTollFreeImpl(parts) {
    return TOLL_FREE_AREA_CODES.includes(parts.npa);
}
exports.isTollFreeImpl = isTollFreeImpl;
